export default __webpack_public_path__ + "static/media/sample_thumbnail.0a51fe4c.png";